module.exports = __webpack_public_path__ + "img/bbc-asian-network.54751a50.png";